import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type ListFilter,
  type MultiFilter,
} from '../types/filters';
import { educationDefinition, educationHandler } from './education';

export const multiEducationDefinition: FilterDefinition<
  MultiFilter<ListFilter>
> = {
  id: FilterId.MULTI_EDUCATION,
  name: 'Education',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.EDUCATION,
  instances: [],
  isVisible: true,
};

export const multiEducationHandler: FilterHandler<MultiFilter<ListFilter>> = {
  isActive(currentFilterState: MultiFilter<ListFilter>) {
    return currentFilterState.instances.some((instance) =>
      educationHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<ListFilter>,
    _definition: FilterDefinition<MultiFilter<ListFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<ListFilter>,
    _definition: FilterDefinition<MultiFilter<ListFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      educationHandler.getEffectiveFilter(instance, educationDefinition, config)
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
